import { useState, useContext } from "react";
import ReusableModal from "../ManageSettings/ReusableModal";
import { toast } from "react-toastify";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ChipList from "../../../common/ReusableComponent/ChipList";
import { RegularButton } from "../../../common/ReusableComponent/CustomButton";

const AddDepartmentModal = ({ show, handleClose, onDepartmentAdded }) => {
  const { user } = useContext(AuthContext);
  const storeId = user.store;
  const { Post, GetPaginatedData } = useApi();
  const [selectedDepartmentList, setSelectedDepartmentList] = useState([]);

  const handleDepartmentSelect = (dept) => {
    if (!dept) return;
    const exists = selectedDepartmentList.some(
      (item) => item.id === dept.id
    );
    if (!exists) {
      setSelectedDepartmentList((prev) => [...prev, dept]);
    }
  };

  const handleRemove = (item) => {
    setSelectedDepartmentList((prev) =>
      prev.filter((dept) => dept.id !== item.id)
    );
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (selectedDepartmentList.length === 0) {
      toast.warn("Please select department");
      return;
    }
    try {
      const payload = selectedDepartmentList.map((item) => ({
        store: storeId,
        all_department: item.id,
        all_expense_type: null
      }));
      const response = await Post("vendorDepartmentServiceData", payload);
      
      if (response.data.total_skipped > 0) {
        toast.warn(response.data.skipped[0].message);
      } else if (response.data.total_created > 0) {
        toast.success("Department added successfully!");
        onDepartmentAdded?.(response.data);
      }
      
      setSelectedDepartmentList([]);
      handleClose();
    } catch (error) {
      console.error("Error saving department:", error);
      const errorData = error.response?.data;
      let errorMessage = "Error saving department";
      
      if (errorData?.total_skipped > 0) {
        errorMessage = errorData.skipped[0].message;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      }
      
      toast.error(errorMessage);
    }
  };

  return (
    <ReusableModal
      show={show}
      handleClose={handleClose}
      title="Add Department"
      width="760px"
      height="300px"
    >
      <form onSubmit={handleSave}>
        { }
        <div className="form-group product-field mt-4">
          <PaginatedSearchSelect
            api="allDepartmentData"
            GetPaginatedData={GetPaginatedData}
            getOptionLabel={(opt) => opt.title || ""}
            onSelect={handleDepartmentSelect}
            placeholder="Select Department"
            pageSize={10}
          />
        </div>
        { }
        <ChipList
          items={selectedDepartmentList}
          onRemove={handleRemove}
          displayField="title"
          keyField="id"
        />
        { }
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <RegularButton
            text="Save"
            onClick={handleSave}
            type="submit"
          />
        </div>
      </form>
    </ReusableModal>
  );
};

export default AddDepartmentModal;